webpackJsonp([1],{

/***/ "+J2U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headingLarge":"_2_q57jrzwXIolyXs6KSIyV_0","textLarge":"_1qnWTImACbrRs3rUhZ39lk_0","centered":"_2VN6zVX6a-rFz-3ftR0HWX_0"};

/***/ }),

/***/ "/02h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSignin_vue__ = __webpack_require__("M0MF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc6a112_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSignin_vue__ = __webpack_require__("Bsj2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSignin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc6a112_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSignin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0CVY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    user: {
      required: true,
      type: Object
    },
    userThreadsCount: {
      required: true,
      type: Number
    },
    userPostsCount: {
      required: true,
      type: Number
    }
  },
  data: function data() {
    return {
      activeUser: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.user)
    };
  },

  methods: {
    save: function save() {
      this.$store.dispatch('updateUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.activeUser));
      this.$router.push({ name: 'Profile' });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Profile' });
    }
  },
  computed: {
    userThreadsCount: function userThreadsCount() {
      return this.$store.getters.userThreadsCount(this.user['.key']);
    },
    userPostsCount: function userPostsCount() {
      return this.$store.getters.userPostsCount(this.user['.key']);
    }
  }
});

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countObjectProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeEmptyProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);



var countObjectProperties = function countObjectProperties(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).length;
  }
  return 0;
};

var removeEmptyProperties = function removeEmptyProperties(obj) {
  var objCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objCopy).forEach(function (key) {
    if (!objCopy[key]) {
      delete objCopy[key];
    }
  });
  return objCopy;
};



/***/ }),

/***/ "2VOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.forums),function(forum){return _c('ForumListItem',{key:forum['.key'],attrs:{"forum":forum}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ZPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadEdit_vue__ = __webpack_require__("awId");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_887f4f9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadEdit_vue__ = __webpack_require__("5YJj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_887f4f9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2aZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      asyncDataStatus_ready: false
    };
  },

  methods: {
    asyncDataStatus_fetched: function asyncDataStatus_fetched() {
      this.asyncDataStatus_ready = true;
      this.$emit('ready');
    }
  }
});

/***/ }),

/***/ "3YjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ForumList__ = __webpack_require__("RxF9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ForumListItem from './ForumListItem'

// import sourceData from '@/data'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // ForumListItem,
    ForumList: __WEBPACK_IMPORTED_MODULE_1__ForumList__["a" /* default */]
  },
  props: {
    category: {
      required: true,
      type: Object
    }
  },
  computed: {
    categoryForums: function categoryForums() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.state.forums).filter(function (forum) {
        return forum.categoryId === _this.category['.key'];
      });
    }
  }
});

/***/ }),

/***/ "3kGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadCreate_vue__ = __webpack_require__("PtMx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10dc0c86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadCreate_vue__ = __webpack_require__("msPH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10dc0c86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5CYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__("VgQg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcedf27c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__("gKTN");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("+J2U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcedf27c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5YJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Editing "),_c('i',[_vm._v(_vm._s(_vm.thread.title))])]),_vm._v(" "),_c('ThreadEditor',{ref:"editor",attrs:{"title":_vm.thread.title,"text":_vm.text},on:{"save":_vm.save,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Ap8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_index__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    forum: {
      required: true,
      type: Object
    }
  },
  computed: {
    threadCount: function threadCount() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_index__["a" /* countObjectProperties */])(this.forum.threads);
      // return this.forum.threads ? Object.values(this.forum.threads).length : 0
    }
  }
});

/***/ }),

/***/ "6blT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumListItem_vue__ = __webpack_require__("6Ap8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6c95e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumListItem_vue__ = __webpack_require__("fzp+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6c95e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6jfm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"thread_title"}},[_vm._v("Title:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-input",attrs:{"type":"text","id":"thread_title","name":"title"},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"thread_content"}},[_vm._v("Content:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.text),expression:"form.text"}],staticClass:"form-input",attrs:{"id":"thread_content","name":"content","rows":"8","cols":"140"},domProps:{"value":(_vm.form.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-ghost",on:{"click":function($event){$event.preventDefault();return _vm.cancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-blue",attrs:{"type":"submit","name":"Publish"}},[_vm._v(_vm._s(_vm.isUpdate ? 'Update' : 'Publish'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7U3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm._f("humanFriendlyDate")(_vm.timestamp)}},[_vm._v(_vm._s(_vm._f("diffForHuman")(_vm.timestamp))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8nKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PostList__ = __webpack_require__("DeYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PostEditor__ = __webpack_require__("TJYQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_index__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import firebase from 'firebase'





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostList: __WEBPACK_IMPORTED_MODULE_5__components_PostList__["a" /* default */],
    PostEditor: __WEBPACK_IMPORTED_MODULE_6__components_PostEditor__["a" /* default */]
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_asyncDataStatus__["a" /* default */]],
  // data () {
  //   return {
  //     // thread: this.$store.state.threads[this.id] removed for property DOWN
  //   }
  // },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    authUser: 'authUser'
  }), {
    thread: function thread() {
      return this.$store.state.threads[this.id];
    },
    posts: function posts() {
      var postIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.thread.posts);
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.$store.state.posts).filter(function (post) {
        return postIds.includes(post['.key']);
      });
    },
    repliesCount: function repliesCount() {
      return this.$store.getters.threadRepliesCount(this.thread['.key']);
    },
    user: function user() {
      return this.$store.state.users[this.thread.userId];
    },
    contributorCount: function contributorCount() {
      // // find the replies
      // const replies = Object.keys(this.thread.posts)
      //                 .filter(postId => postId !== this.thread.firstPostId)
      //                 .map(postId => this.$store.state.posts[postId])
      // // get the user ids
      // const userId = replies.map(post => post.userId)
      // // count the unique ids
      // return userId.filter((item, index) => userId.indexOf(item) === index).length
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_index__["a" /* countObjectProperties */])(this.thread.contributors);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['fetchThread', 'fetchUser', 'fetchPosts'])),
  beforeCreate: function beforeCreate() {
    // this.id = undefined
  },
  created: function created() {
    var _this = this;

    // console.log('show created *****')
    // prototype
    // fetch thread
    // firebase.database().ref('threads').child(this.id).once('value', snapshot => {
    //   const thread = snapshot.val()
    //   this.$store.commit('setThread', {threadId: snapshot.key, thread: {...thread, '.key': snapshot.key}})
    //   // fetch user
    //   firebase.database().ref('users').child(thread.userId).once('value', snapshot => {
    //     const user = snapshot.val()
    //     this.$store.commit('setUser', {userId: snapshot.key, user: {...user, '.key': snapshot.key}})
    //   })
    //
    //   Object.keys(thread.posts).forEach(postId => {
    //     // fetch post
    //     firebase.database().ref('posts').child(postId).once('value', snapshot => {
    //       const post = snapshot.val()
    //       this.$store.commit('setPost', {postId: snapshot.key, post: {...post, '.key': snapshot.key}})
    //
    //       // fetch user
    //       firebase.database().ref('users').child(post.userId).once('value', snapshot => {
    //         const user = snapshot.val()
    //         this.$store.commit('setUser', {userId: snapshot.key, user: {...user, '.key': snapshot.key}})
    //       })
    //     })
    //   })
    // })

    // fetch thread
    this.fetchThread({ id: this.id }).then(function (thread) {
      // fetch user
      _this.fetchUser({ id: thread.userId });
      return _this.fetchPosts({ ids: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(thread.posts) });
    }).then(function (posts) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(posts.map(function (post) {
        _this.fetchUser({ id: post.userId });
      })).then(function () {
        return _this.asyncDataStatus_fetched();
      });

      // REPLACED WITH fetchPosts
      // Object.keys(thread.posts).forEach(postId => {
      //   // fetch post
      //   this.$store.dispatch('fetchPost', {id: postId})
      //   .then(post => {
      //     // fetch user
      //     this.$store.dispatch('fetchUser', {id: post.userId})
      //   })
      // })
    });
  }

  // methods: {
  //   addPost ({ post }) {
  //     // const postId = post['.key']

  //     // this.$set(this.$store.state.posts, postId, post)
  //     // this.$set(this.thread.posts, postId, postId)
  //     // this.$set(this.$store.state.users[post.userId].posts, postId, postId)
  //     // sets moved to store.index - mutations
  //     // console.log(eventData)
  //     this.$store.dispatch('createPost', post)
  //   }
  // }

});

/***/ }),

/***/ "8t4W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PagethreadShow_vue__ = __webpack_require__("8nKX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef8f8a10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PagethreadShow_vue__ = __webpack_require__("aq1r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PagethreadShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef8f8a10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PagethreadShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9TRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavbar_vue__ = __webpack_require__("nJYp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c948eac4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavbar_vue__ = __webpack_require__("Pxbv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c948eac4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9oCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ForumListItem__ = __webpack_require__("6blT");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ForumListItem: __WEBPACK_IMPORTED_MODULE_0__ForumListItem__["a" /* default */]
  },
  props: {
    forums: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "AgMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grid justify-center"},[_c('div',{staticClass:"col-2"},[_c('form',{staticClass:"card card-form",on:{"submit":function($event){$event.preventDefault();return _vm.register($event)}}},[_c('h1',{staticClass:"text-center"},[_vm._v("Register")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-input",attrs:{"id":"name","type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"username"}},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.username),expression:"form.username"}],staticClass:"form-input",attrs:{"id":"username","type":"text"},domProps:{"value":(_vm.form.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-input",attrs:{"id":"email","type":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-input",attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"avatar"}},[_vm._v("Avatar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.avatar),expression:"form.avatar"}],staticClass:"form-input",attrs:{"id":"avatar","type":"text"},domProps:{"value":(_vm.form.avatar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "avatar", $event.target.value)}}})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"text-center push-top"},[_c('button',{staticClass:"btn-red btn-xsmall",on:{"click":_vm.registerWithGoogle}},[_c('i',{staticClass:"fa fa-google fa-btn"}),_vm._v("Sign up with Google")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn-blue btn-block",attrs:{"type":"submit"}},[_vm._v("Register")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bsj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grid justify-center"},[_c('div',{staticClass:"col-2"},[_c('form',{staticClass:"card card-form",on:{"submit":function($event){$event.preventDefault();return _vm.signIn($event)}}},[_c('h1',{staticClass:"text-center"},[_vm._v("Login")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-input",attrs:{"id":"email","type":"text"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-input",attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-actions text-right"},[_c('router-link',{attrs:{"to":{name: 'Register'}}},[_vm._v("Create an account?")])],1)]),_vm._v(" "),_c('div',{staticClass:"push-top text-center"},[_c('button',{staticClass:"btn-red btn-xsmall",on:{"click":_vm.signInWithGoogle}},[_c('i',{staticClass:"fa fa-google fa-btn"}),_vm._v("Sign in with Google")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-top"},[_c('button',{staticClass:"btn-blue btn-block",attrs:{"type":"submit"}},[_vm._v("Log in")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "COEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadList_vue__ = __webpack_require__("iy9d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc1efbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadList_vue__ = __webpack_require__("FuRD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc1efbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ClcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppDate_vue__ = __webpack_require__("rQVF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e55c144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppDate_vue__ = __webpack_require__("7U3v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e55c144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DeYy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostList_vue__ = __webpack_require__("b4MN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716e1f82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostList_vue__ = __webpack_require__("dfxI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716e1f82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FuRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thread-list"},[_c('h2',{staticClass:"list-title"},[_vm._v("Threads")]),_vm._v(" "),_vm._l((_vm.threads),function(thread){return _c('ThreadListItem',{key:thread['.key'],attrs:{"thread":thread}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HXr5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I4wM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    user: {
      required: true,
      type: Object
      // >> removed by using dynamic getters
      // userThreadsCount: {
      //   required: true,
      //   type: Number
      // },
      // userPostsCount: {
      //   required: true,
      //   type: Number
      // }
    } },
  computed: {
    userThreadsCount: function userThreadsCount() {
      return this.$store.getters.userThreadsCount(this.user['.key']);
    },
    userPostsCount: function userPostsCount() {
      return this.$store.getters.userPostsCount(this.user['.key']);
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");





// import sourceData from '@/data' >> using real DB
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    categories: {},
    forums: {},
    posts: {},
    threads: {},
    users: {},
    authId: null,
    unsubescribeAuthObserver: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ "IqJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostEditor__ = __webpack_require__("TJYQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import sourceData from '@/data'
// import {countObjectProperties} from '@/utils/index' >> using Dynamic getters


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    post: {
      required: true,
      type: Object
    }
  },
  components: {
    PostEditor: __WEBPACK_IMPORTED_MODULE_0__PostEditor__["a" /* default */]
  },
  data: function data() {
    return {
      editing: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.state.users[this.post.userId];
    },
    userPostCount: function userPostCount() {
      return this.$store.getters.userPostsCount(this.post.userId);
      // return countObjectProperties(this.user.posts)
      // return Object.keys(this.user.posts).length
    },
    userThreadCount: function userThreadCount() {
      return this.$store.getters.userThreadsCount(this.post.userId);
    }
  }
});

/***/ }),

/***/ "J/FS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forum-list"},[_c('h2',{staticClass:"list-title"},[_c('router-link',{attrs:{"to":{name: 'Category', params: {id : _vm.category['.key']}}}},[_vm._v("\n          "+_vm._s(_vm.category.name)+"\n        ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"}})],1),_vm._v(" "),_c('ForumList',{attrs:{"forums":_vm.categoryForums}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JDzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full"},[_c('h1',[_vm._v(_vm._s(_vm.category.name))]),_vm._v(" "),_c('CategoryListItem',{attrs:{"category":_vm.category}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JO/1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCart_vue__ = __webpack_require__("I4wM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ad33e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCart_vue__ = __webpack_require__("XZnA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ad33e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M0MF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        email: null,
        password: null
      }
    };
  },

  methods: {
    signIn: function signIn() {
      var _this = this;

      this.$store.dispatch('signinWithEmailAndPassword', {
        email: this.form.email,
        password: this.form.password
      }).then(function () {
        return _this.successRedirect();
      }).catch(function (error) {
        return alert(error.message);
      });
    },
    signInWithGoogle: function signInWithGoogle() {
      var _this2 = this;

      this.$store.dispatch('signinWithGoogle').then(function () {
        return _this2.successRedirect();
      }).catch(function (error) {
        return alert(error.message);
      });
    },
    successRedirect: function successRedirect() {
      var redirectTo = this.$route.query.redirectTo || { name: 'Home' // $route (ACTIVE route) !== $router (Global router instance)
      };this.$router.push(redirectTo);
    }
  },
  created: function created() {
    this.$emit('ready');
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aad1ab68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("j+SD");
function injectStyle (ssrContext) {
  __webpack_require__("tFgn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aad1ab68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MzKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CategoryListItem__ = __webpack_require__("u7GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//




// import sourceData from '@/data'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CategoryListItem: __WEBPACK_IMPORTED_MODULE_2__components_CategoryListItem__["a" /* default */]
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__["a" /* default */]],
  computed: {
    category: function category() {
      return this.$store.state.categories[this.id];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchCategory', 'fetchForums'])),
  created: function created() {
    var _this = this;

    this.fetchCategory({ id: this.id }).then(function (category) {
      _this.fetchForums({ ids: category.forums });
    }).then(function (category) {
      _this.asyncDataStatus_fetched();
    });
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppDate__ = __webpack_require__("ClcQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('AppDate', __WEBPACK_IMPORTED_MODULE_4__components_AppDate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Initialize Firebase
var config = {
  apiKey: "AIzaSyCpE5ncxcxWmjWzuLjc0ppw3dc-XLglTm4",
  authDomain: "hovikvueschoolforum.firebaseapp.com",
  databaseURL: "https://hovikvueschoolforum.firebaseio.com",
  projectId: "hovikvueschoolforum",
  storageBucket: "",
  messagingSenderId: "852367972944"
};
__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.initializeApp(config);
// MOVED TO actions
// firebase.auth().onAuthStateChanged(user => {
//   if (user) {
//     store.dispatch('fetchAuthUser')
//   }
// })

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
    // beforeCreate () {
    //   store.dispatch('fetchUser', {id: store.state.authId})
    // }
  } });

/***/ }),

/***/ "NMPn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        title: this.title,
        text: this.text
      }
    };
  },

  computed: {
    isUpdate: function isUpdate() {
      return !!this.title;
    }
  },
  methods: {
    save: function save() {
      this.$emit('save', { title: this.form.title, text: this.form.text });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "OxT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCartEditor_vue__ = __webpack_require__("0CVY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c45d01da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCartEditor_vue__ = __webpack_require__("XvS1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCartEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c45d01da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCartEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PtMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__ = __webpack_require__("wEhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadEditor: __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__["a" /* default */]
  },
  props: {
    forumId: {
      required: true,
      type: String
    }
  },
  data: function data() {
    return {
      saved: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__["a" /* default */]],
  // DATA removed with ThreadEditor
  // data () {
  //   return {
  //     title: '',
  //     text: ''
  //   }
  // },
  computed: {
    forum: function forum() {
      return this.$store.state.forums[this.forumId];
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      return (this.$refs.editor.form.title || this.$refs.editor.form.text) && !this.saved;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['createThread', 'fetchForum']), {
    save: function save(_ref) {
      var _this = this;

      var title = _ref.title,
          text = _ref.text;

      this.createThread({
        forumId: this.forum['.key'],
        title: title,
        text: text
      }).then(function (thread) {
        _this.saved = true;
        _this.$router.push({ name: 'ThreadShow', params: { id: thread['.key'] } });
      });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Forum', params: { id: this.forum['.key'] } });
    }
  }),
  created: function created() {
    var _this2 = this;

    this.fetchForum({ id: this.forumId }).then(function () {
      return _this2.asyncDataStatus_fetched();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      var confirmed = window.confirm('Are you sure ?');
      if (confirmed) {
        next();
      } else {
        next(false);
      }
    } else {
      // no change
      next();
    }
  }
});

/***/ }),

/***/ "Pxbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"id":"header"}},[_c('router-link',{staticClass:"logo",attrs:{"to":{name: 'Home'}}},[_c('img',{attrs:{"src":__webpack_require__("YaDf")}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"navbar"},[(_vm.user)?_c('ul',[_c('li',{staticClass:"navbar-user"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.userDropdownOpen = !_vm.userDropdownOpen}}},[_c('img',{staticClass:"avatar-small",attrs:{"src":_vm.user.avatar,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("\n                      "+_vm._s(_vm.user.name)+"\n                      "),_c('img',{staticClass:"icon-profile",attrs:{"src":__webpack_require__("ba8D"),"alt":""}})])]),_vm._v(" "),_c('div',{class:{'active-drop': _vm.userDropdownOpen},attrs:{"id":"user-dropdown"}},[_c('div',{staticClass:"triangle-drop"}),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"dropdown-menu-item"},[_c('router-link',{attrs:{"to":{name: 'Profile'}}},[_vm._v("View profile")])],1),_vm._v(" "),_c('li',{staticClass:"dropdown-menu-item"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.$store.dispatch('signOut')}}},[_vm._v("Sign Out")])])])])])]):_c('ul',[_c('li',{staticClass:"navbar-item"},[_c('router-link',{attrs:{"to":{name: 'SignIn'}}},[_vm._v("Sign In")])],1),_vm._v(" "),_c('li',{staticClass:"navbar-item"},[_c('router-link',{attrs:{"to":{name: 'Register'}}},[_vm._v("Register")])],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-hamburger"},[_c('div',{staticClass:"top bar"}),_vm._v(" "),_c('div',{staticClass:"middle bar"}),_vm._v(" "),_c('div',{staticClass:"bottom bar"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RxF9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumList_vue__ = __webpack_require__("9oCC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_999a0cea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumList_vue__ = __webpack_require__("2VOM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_999a0cea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sv3r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TJYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostEditor_vue__ = __webpack_require__("w+/a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5d46d8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostEditor_vue__ = __webpack_require__("ir2G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5d46d8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("0xDb");


/* harmony default export */ __webpack_exports__["a"] = ({
  authUser: function authUser(state) {
    return state.authId ? state.users[state.authId] : null;
  },

  userPosts: function userPosts(state) {
    return function (id) {
      var user = state.users[id];
      if (user.posts) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.posts).filter(function (post) {
          return post.userId === id;
        });
      }
      return [];
    };
  },
  userThreadsCount: function userThreadsCount(state) {
    return function (id) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* countObjectProperties */])(state.users[id].threads);
    };
  },
  userPostsCount: function userPostsCount(state) {
    return function (id) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* countObjectProperties */])(state.users[id].posts);
    };
  },
  // ^^
  // userPostsCount (state) {
  //   return function (id) {
  //     return countObjectProperties(state.users[id].posts)
  //   }
  // }
  threadRepliesCount: function threadRepliesCount(state) {
    return function (id) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* countObjectProperties */])(state.threads[id].posts) - 1;
    };
  }
});

/***/ }),

/***/ "Usei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: null,
        username: null,
        email: null,
        password: null,
        avatar: null
      }
    };
  },

  methods: {
    register: function register() {
      var _this = this;

      this.$store.dispatch('registerUserWithEmailandPassword', this.form).then(function () {
        return _this.$router.push('/');
      });
    },
    registerWithGoogle: function registerWithGoogle() {
      var _this2 = this;

      this.$store.dispatch('signinWithGoogle').then(function () {
        return _this2.$router.push('/');
      });
    }
  },
  created: function created() {
    this.$emit('ready');
  }
});

/***/ }),

/***/ "VgQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$emit('ready');
  }
});

/***/ }),

/***/ "Wzdu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageRegister_vue__ = __webpack_require__("Usei");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24119579_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageRegister_vue__ = __webpack_require__("AgMy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24119579_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XZnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3 push-top"},[_c('div',{staticClass:"profile-card"},[_c('p',{staticClass:"text-center"},[_c('img',{staticClass:"avatar-xlarge",attrs:{"src":_vm.user.avatar,"alt":""}})]),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.user.username))]),_vm._v(" "),_c('p',{staticClass:"text-lead"},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('p',{staticClass:"text-justify"},[(_vm.user.bio)?_c('span',[_vm._v(_vm._s(_vm.user.bio))]):_c('span',[_vm._v("No bio specified.")])]),_vm._v(" "),_c('span',{staticClass:"online"},[_vm._v(_vm._s(_vm.user.username)+" is online")]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('span',[_vm._v(_vm._s(_vm.userPostsCount)+" posts")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userThreadsCount)+" threads")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.user.website)?_c('p',{staticClass:"text-large text-center"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.user.website}},[_vm._v(_vm._s(_vm.user.website))])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"text-xsmall text-faded text-center"},[_vm._v("Member since june 2003, last visited 4 hours ago")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('hr'),_vm._v(" "),_c('router-link',{staticClass:"btn-green btn-small",attrs:{"to":{name: 'ProfileEdit'}}},[_vm._v("\n        Edit Profile\n      ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XvS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3 push-top"},[_c('div',{staticClass:"profile-card"},[_c('p',{staticClass:"text-center"},[_c('img',{staticClass:"avatar-xlarge img-update",attrs:{"src":_vm.user.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.username),expression:"activeUser.username"}],staticClass:"form-input text-lead text-bold",attrs:{"type":"text","placeholder":"Username"},domProps:{"value":(_vm.activeUser.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.name),expression:"activeUser.name"}],staticClass:"form-input text-lead",attrs:{"type":"text","placeholder":"Full Name"},domProps:{"value":(_vm.activeUser.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"user_bio"}},[_vm._v("Bio")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.bio),expression:"activeUser.bio"}],staticClass:"form-input",attrs:{"id":"user_bio","placeholder":"Write a few words about yourself."},domProps:{"value":(_vm.activeUser.bio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "bio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('span',[_vm._v(_vm._s(_vm.userPostsCount)+" posts")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userThreadsCount)+" threads")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label",attrs:{"for":"user_website"}},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.website),expression:"activeUser.website"}],staticClass:"form-input",attrs:{"autocomplete":"off","id":"user_website"},domProps:{"value":(_vm.activeUser.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "website", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label",attrs:{"for":"user_email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.email),expression:"activeUser.email"}],staticClass:"form-input",attrs:{"autocomplete":"off","id":"user_email"},domProps:{"value":(_vm.activeUser.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label",attrs:{"for":"user_location"}},[_vm._v("Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.location),expression:"activeUser.location"}],staticClass:"form-input",attrs:{"autocomplete":"off","id":"user_location"},domProps:{"value":(_vm.activeUser.location)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "location", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group space-between"},[_c('button',{staticClass:"btn-ghost",on:{"click":function($event){$event.preventDefault();return _vm.cancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn-blue",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_vm._v("Save")])])]),_vm._v(" "),_c('p',{staticClass:"text-xsmall text-faded text-center"},[_vm._v("Member since june 2003, last visited 4 hours ago")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaDf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjExMi42IC0yNDcuNSA0MCA0NSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAxMTIuNiAtMjQ3LjUgNDAgNDUiIHhtbDpzcGFjZT0icHJlc2VydmUiPgoJPGc+CgkJCQk8ZyBpZD0iTGF5ZXJfMTQiPgoJCQkJCTxwYXRoIGZpbGw9IiNGRjY2QzgiIGQ9Ik0xNDIuOC0yMzkuN2MwLDAsMC44LTEuNCwyLjMtMC43YzEuNSwwLjcsNi4xLDIuNyw2LjEsMi43czIuMSwwLjcsMS4yLDIuOGMtMC43LDEuNS0yLjcsNi4yLTIuNyw2LjIKCQkJCQkJbC05LjYtNC42TDE0Mi44LTIzOS43TDE0Mi44LTIzOS43eiIvPgoJCQkJPC9nPgoJCQkJPGcgaWQ9IkxheWVyXzExIj4KCQkJCQk8cGF0aCBmaWxsPSIjRDJEOEQ1IiBkPSJNMTQwLjctMjM0LjdsMi42LDEuOGwzLjcsMS42bDMuNSwwLjdsLTEuOSw0LjFjMCwwLTguOCw2LjUtOS43LTQuMkwxNDAuNy0yMzQuN0wxNDAuNy0yMzQuN3oiLz4KCQkJCTwvZz4KCQkJCTxnIGlkPSJMYXllcl84Ij4KCQkJCQk8cG9seWdvbiBmaWxsPSIjMTU3QTRBIiBwb2ludHM9IjE0OS40LC0yMjguMiAxNDUuOSwtMjI5IDE0Mi4yLC0yMzAuNiAxMzkuNywtMjMyLjQgMTI5LC0yMDguMiAxMzgsLTIwMi42IAkJIi8+CgkJCQk8L2c+CgkJCQk8ZyBpZD0iTGF5ZXJfMSI+CgkJCQkJPHBvbHlnb24gZmlsbD0iIzIyQjU3MyIgcG9pbnRzPSIxMzgsLTIwMi41IDEyNS4zLC0yMDIuNSAxMTIuNiwtMjM0LjIgMTIzLjUsLTIzOC43IAkJIi8+CgkJCQk8L2c+CgkJCQk8ZyBpZD0iTGF5ZXJfMiI+CgkJCQkJPHBhdGggZmlsbD0iI0ZGREFBRSIgZD0iTTExMi42LTIzNC4ybDEuMi0xMy4ybDkuNyw4LjdjMCwwLTEuNywyLjItMy44LDEuNmMwLDAtMC45LDEuOS0zLjQsMS40CgkJCQkJCUMxMTYuMy0yMzUuOCwxMTUuMS0yMzMuNCwxMTIuNi0yMzQuMnoiLz4KCQkJCTwvZz4KCQkJCTxnIGlkPSJMYXllcl83Ij4KCQkJCQk8cGF0aCBkPSJNMTE1LjEtMjQ2LjNsLTEuMy0xLjJsLTAuMywzLjJjMC4xLDAsMS44LTAuNCwyLjUtMS4yQzExNi0yNDUuNSwxMTUuMS0yNDYuMywxMTUuMS0yNDYuM3oiLz4KCQkJCTwvZz4KCQkJCTwvZz4KPC9zdmc+"

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_PageHome__ = __webpack_require__("zosi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_PagethreadShow__ = __webpack_require__("8t4W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_PageThreadCreate__ = __webpack_require__("3kGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_PageThreadEdit__ = __webpack_require__("2ZPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_PageForum__ = __webpack_require__("mAT4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_PageCategory__ = __webpack_require__("b5o+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_PageNotFound__ = __webpack_require__("5CYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_PageProfile__ = __webpack_require__("ecxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PageRegister__ = __webpack_require__("Wzdu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_PageSignin__ = __webpack_require__("/02h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("IcnI");














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_PageHome__["a" /* default */]
  }, {
    path: '/forum/:id',
    name: 'Forum',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_PageForum__["a" /* default */],
    props: true
  }, {
    path: '/category/:id',
    name: 'Category',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_PageCategory__["a" /* default */],
    props: true
  }, {
    path: '/me',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_PageProfile__["a" /* default */],
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/me/edit',
    name: 'ProfileEdit',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_PageProfile__["a" /* default */],
    props: { edit: true },
    meta: { requiresAuth: true }
  }, {
    path: '/thread/create/:forumId',
    name: 'ThreadCreate',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_PageThreadCreate__["a" /* default */],
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/thread/:id/edit',
    name: 'ThreadEdit',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_PageThreadEdit__["a" /* default */],
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/thread/:id',
    name: 'ThreadShow',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_PagethreadShow__["a" /* default */],
    props: true
  }, {
    path: '/register',
    name: 'Register',
    meta: { requiresGuest: true },
    component: __WEBPACK_IMPORTED_MODULE_10__pages_PageRegister__["a" /* default */]
  }, {
    path: '/signin',
    name: 'SignIn',
    meta: { requiresGuest: true },
    component: __WEBPACK_IMPORTED_MODULE_11__pages_PageSignin__["a" /* default */]
  }, {
    path: '/logout',
    name: 'SignOut',
    meta: { requiresAuth: true },
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('signOut').then(function () {
        return next({ name: 'Home' });
      });
    }
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_PageNotFound__["a" /* default */]
  }]
  // mode: 'history'
});

router.beforeEach(function (to, from, next) {
  console.log('Navigating to ' + to.name + ' from ' + from.name);
  // console.log(to.matched)
  // if (to.meta.requiresAuth) { OLD replaced with below
  __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('initAuthentication').then(function (user) {
    if (to.matched.some(function (route) {
      return route.meta.requiresAuth;
    })) {
      // check nested routes too
      if (user) {
        next();
      } else {
        next({ name: 'SignIn', query: { redirectTo: to.path } });
      }
    } else if (to.matched.some(function (route) {
      return route.meta.requiresGuest;
    })) {
      // check nested routes too
      if (!user) {
        next();
      } else {
        next({ name: 'Home' }); // or next('/')
      }
    } else {
      next();
    }
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZH5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aq1r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready  )?_c('div',{staticClass:"col-large push-top"},[_c('h1',[_vm._v(_vm._s(_vm.thread.title)+"\n    "),_c('router-link',{staticClass:"btn-green btn-small",attrs:{"to":{name: 'ThreadEdit', id:this.id},"tag":"button"}},[_vm._v("\n      Edit thread\n    ")])],1),_vm._v(" "),_c('p',[_vm._v("\n      By "),_c('a',{staticClass:"link-unstyled",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(", "),_c('AppDate',{attrs:{"timestamp":_vm.thread.publishedAt}}),_vm._v(".\n      "),_c('span',{staticClass:"hide-mobile text-faded text-small",staticStyle:{"float":"right","margin-top":"2px"}},[_vm._v(_vm._s(_vm.repliesCount)+" replies by "+_vm._s(_vm.contributorCount)+" contributors")])],1),_vm._v(" "),_c('PostList',{attrs:{"posts":_vm.posts}}),_vm._v(" "),(_vm.authUser)?_c('PostEditor',{attrs:{"threadId":_vm.id}}):_c('div',{staticClass:"text-center",staticStyle:{"margin-buttom":"50px"}},[_c('router-link',{attrs:{"to":{name: 'SignIn', query: {redirectTo: _vm.$route.path}}}},[_vm._v("Sign in")]),_vm._v(" or \n    "),_c('router-link',{attrs:{"to":{name: 'Register', query: {redirectTo: _vm.$route.path}}}},[_vm._v("Register")]),_vm._v(" to post a reply.\n  ")],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "arqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Welcome to the Forum")]),_vm._v(" "),_c('CategoryList',{attrs:{"categories":_vm.categories}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "awId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__ = __webpack_require__("wEhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadEditor: __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__["a" /* default */]
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data: function data() {
    return {
      saved: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__["a" /* default */]],
  computed: {
    thread: function thread() {
      return this.$store.state.threads[this.id];
    },
    text: function text() {
      var post = this.$store.state.posts[this.thread.firstPostId];
      return post ? post.text : null;
    },
    dataHasNotChanged: function dataHasNotChanged() {
      // const thread = thread
      return (this.$refs.editor.form.title && this.$refs.editor.form.title !== this.thread.title || this.$refs.editor.form.text !== this.text) && !this.saved;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateThread', 'fetchPost', 'fetchThread']), {
    save: function save(_ref) {
      var _this = this;

      var title = _ref.title,
          text = _ref.text;

      // ORIGINAL >> this.$store.dispatch('updateThread', {
      this.updateThread({
        id: this.id,
        title: title,
        text: text
      }).then(function (thread) {
        _this.saved = true;
        _this.$router.push({ name: 'ThreadShow', params: { id: _this.id } });
      });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'ThreadShow', params: { id: this.id } });
    }
  }),
  created: function created() {
    var _this2 = this;

    // OROGINAL this.$store.dispatch('fetchThread', {id: this.id})
    this.$store.dispatch('fetchThread', { id: this.id }).then(function (thread) {
      return _this2.fetchPost({ id: thread.firstPostId });
    }).then(function () {
      return _this2.asyncDataStatus_fetched();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.dataHasNotChanged) {
      var confirmed = window.confirm('sure ?');
      if (confirmed) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "b4MN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostListItem__ = __webpack_require__("kqo0");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostListItem: __WEBPACK_IMPORTED_MODULE_0__PostListItem__["a" /* default */]
  },
  props: {
    posts: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "b5o+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageCategory_vue__ = __webpack_require__("MzKp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2b1a58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageCategory_vue__ = __webpack_require__("JDzU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2b1a58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ba8D":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiPgogICAgPHBvbHlsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzU3QUQ4RCIgc3Ryb2tlLXdpZHRoPSIyIiBwb2ludHM9IjEzOTYuNjQyIDQyLjM0OCAxNDAxLjIyMyA0Ny4zNDggMTQwNi4xNjEgNDIuMzQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTM5NSAtNDEpIi8+Cjwvc3ZnPg=="

/***/ }),

/***/ "dAPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"fullwidth"},[_c('div',{staticClass:"col-full push-top"},[_c('div',{staticClass:"forum-header"},[_c('div',{staticClass:"forum-details"},[_c('h1',[_vm._v(_vm._s(_vm.forum.name))]),_vm._v(" "),_c('p',{staticClass:"text-lead"},[_vm._v(_vm._s(_vm.forum.description))])]),_vm._v(" "),_c('router-link',{staticClass:"btn-green btn-small",attrs:{"to":{name: 'ThreadCreate', params: {forumId: this.forum['.key']}}}},[_vm._v("\n              Start a thread\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-full"},[_c('ThreadList',{attrs:{"threads":_vm.threads}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dfxI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-list"},_vm._l((_vm.posts),function(post){return _c('postListItem',{key:post['.key'],attrs:{"post":post}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ecxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageProfile_vue__ = __webpack_require__("nVtz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740ac67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageProfile_vue__ = __webpack_require__("y4/U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740ac67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fzp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forum-listing"},[_c('div',{staticClass:"forum-details"},[_c('router-link',{staticClass:"text-xlarge",attrs:{"to":{name: 'Forum', params: {id : _vm.forum['.key']}}}},[_vm._v("\n              "+_vm._s(_vm.forum.name)+"\n        ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forum.description))])],1),_vm._v(" "),_c('div',{staticClass:"threads-count"},[_c('p',{staticClass:"count"},[_vm._v(_vm._s(_vm.threadCount))]),_vm._v(" \n        "+_vm._s(_vm.threadCount === 1 ? 'thread' : 'threads')+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"last-thread"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gKTN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-full centered",class:_vm.$style.centered},[_c('h1',{class:_vm.$style.headingLarge},[_vm._v("Not Found")]),_vm._v(" "),_c('p',{class:_vm.$style.textLarge},[_vm._v("\n        Opps...\n        "),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("\n            go to home page\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hHtz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post && _vm.user)?_c('div',{staticClass:"post"},[_c('div',{staticClass:"user-info"},[_c('a',{staticClass:"user-name",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{staticClass:"avatar-large",attrs:{"src":_vm.user.avatar,"alt":""}})]),_vm._v(" "),_c('p',{staticClass:"desktop-only text-small"},[_vm._v(_vm._s(_vm.userThreadCount)+" Threads")]),_vm._v(" "),_c('p',{staticClass:"desktop-only text-small"},[_vm._v(_vm._s(_vm.userPostCount)+" posts")])]),_vm._v(" "),_c('div',{staticClass:"post-content"},[(!_vm.editing)?[_c('div',[_vm._v("\n            "+_vm._s(_vm.post.text)+"\n        ")]),_vm._v(" "),_c('a',{staticClass:"link-unstyled",staticStyle:{"margin-left":"auto"},attrs:{"href":"#","title":"Make a change"},on:{"click":function($event){$event.preventDefault();_vm.editing = true}}},[_c('i',{staticClass:"fa fa-pencil"})])]:_c('div',[_c('PostEditor',{attrs:{"post":_vm.post},on:{"save":function($event){_vm.editing = false},"cancel":function($event){_vm.editing = false}}})],1)],2),_vm._v(" "),_c('div',{staticClass:"post-date text-faded"},[(_vm.post.edited)?_c('div',{staticClass:"edition-info"},[_vm._v("edited")]):_vm._e(),_vm._v(" "),_c('AppDate',{attrs:{"timestamp":_vm.post.publishedAt}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ir2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"form-input",attrs:{"name":"","id":"","cols":"30","rows":"10"},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[(_vm.isUpdate)?_c('button',{staticClass:"btn btn-ghost",on:{"click":function($event){$event.preventDefault();return _vm.cancel($event)}}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn-blue"},[_vm._v(_vm._s(_vm.isUpdate ? 'Update' : 'Submit post'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iy9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThreadListItem__ = __webpack_require__("oEgK");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadListItem: __WEBPACK_IMPORTED_MODULE_0__ThreadListItem__["a" /* default */]
  },
  props: {
    threads: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "j+SD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('TheNavbar'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage),expression:"showPage"}],key:_vm.$route.path,on:{"ready":_vm.pageReady}}),_vm._v(" "),_c('Spinner',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPage),expression:"!showPage"}]})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jmvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryListItem__ = __webpack_require__("u7GP");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CategoryListItem: __WEBPACK_IMPORTED_MODULE_0__CategoryListItem__["a" /* default */]
  },
  props: {
    categories: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "kqo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostListItem_vue__ = __webpack_require__("IqJq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea08082e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostListItem_vue__ = __webpack_require__("hHtz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea08082e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lMYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CategoryList__ = __webpack_require__("rlI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");




//
//
//
//
//
//
//
//
//
//

// import sourceData from '@/data.json'
// import ThreadList from '@/components/ThreadList'
// import ForumList from '@/components/ForumList'



// console.log(sourceData)
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // ForumList,
    CategoryList: __WEBPACK_IMPORTED_MODULE_5__components_CategoryList__["a" /* default */]
    // ThreadList
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_asyncDataStatus__["a" /* default */]],
  computed: {
    categories: function categories() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.$store.state.categories);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['fetchAllCategories', 'fetchForums'])),
  created: function created() {
    var _this = this;

    // original beforeCreate - changed for vuex MapActions
    console.log('beforeCreate', this.categories);
    this.fetchAllCategories().then(function (categories) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(categories.map(function (category) {
        return _this.fetchForums({ ids: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(category.forums) });
      })).then(function () {
        _this.asyncDataStatus_fetched();
      });
    });
  },

  // created () {
  //   console.log('created', this.categories)
  // },
  beforeMount: function beforeMount() {
    // console.log('beforeMount', this.categories)
  },
  mounted: function mounted() {
    // = ready in JQ
    // console.log('Mount', this.categories, this.$el)
  },
  beforeDestroy: function beforeDestroy() {
    // turn off listeners like firebase
    // console.log('beforeDestroy', this.categories)
  },
  destroyed: function destroyed() {}
  // console.log('Destroy', this.categories)

  // data () {  data -> computed = best plactice
  //   return {
  //     // threads: Object.values(sourceData.threads),
  //     // forums: Object.values(sourceData.forums),
  //     categories: Object.values(this.$store.state.categories)
  //     // posts: sourceData.posts,
  //     // users: sourceData.users
  //   }
  // }

});

/***/ }),

/***/ "m0Of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.categories),function(category){return _c('CategoryListItem',{key:category['.key'],attrs:{"category":category}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mAT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageForum_vue__ = __webpack_require__("skxu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353db576_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageForum_vue__ = __webpack_require__("dAPf");
function injectStyle (ssrContext) {
  __webpack_require__("Sv3r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageForum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353db576_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageForum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mP6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thread && _vm.user)?_c('div',{staticClass:"thread"},[_c('div',[_c('p',[_c('router-link',{attrs:{"to":{name: 'ThreadShow', params:{id:_vm.thread['.key']}}}},[_vm._v("\n          "+_vm._s(_vm.thread.title)+"\n        ")])],1),_vm._v(" "),_c('p',{staticClass:"text-faded text-xsmall"},[_vm._v("\n            By "),_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(", "),_c('AppDate',{attrs:{"timestamp":_vm.thread.publishedAt}}),_vm._v(".\n        ")],1)]),_vm._v(" "),_c('div',{staticClass:"activity"},[_c('p',{staticClass:"replies-count"},[_vm._v("\n            "+_vm._s(_vm.repliesCount)+" replies\n        ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");







/* harmony default export */ __webpack_exports__["a"] = ({
  createPost: function createPost(_ref, post) {
    var commit = _ref.commit,
        state = _ref.state;

    var postId = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('posts').push().key; // 'greatPost' + Math.random()
    // post['.key'] = postId
    post.userId = state.authId;
    post.publishedAt = Math.floor(Date.now() / 1000);

    var updates = {};
    updates['posts/' + postId] = post;
    updates['threads/' + post.threadId + '/posts/' + postId] = postId;
    updates['threads/' + post.threadId + '/contributors/' + post.userId] = post.userId;
    updates['users/' + post.userId + '/posts/' + postId] = postId;
    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref().update(updates).then(function () {
      commit('setItem', { resource: 'posts', item: post, id: postId }); // removed << commit('setPost', {post, postId})
      commit('appendPostToThread', { parentId: post.threadId, childId: postId });
      commit('appendContributorToThread', { parentId: post.threadId, childId: post.userId });
      commit('appendPostToUser', { parentId: post.userId, childId: postId });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(state.posts[postId]);
    });
  },
  updatePost: function updatePost(_ref2, _ref3) {
    var state = _ref2.state,
        commit = _ref2.commit;
    var id = _ref3.id,
        text = _ref3.text;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var post = state.posts[id];
      var edited = {
        at: Math.floor(Date.now() / 1000),
        by: state.authId
      };

      var updates = { text: text, edited: edited };
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('posts').child(id).update(updates).then(function () {
        commit('setPost', { postId: id, post: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, post, { text: text, edited: edited }) });
        resolve(post);
      });
    });
  },
  updateUser: function updateUser(_ref4, user) {
    var commit = _ref4.commit;

    var updates = {
      avatar: user.avatar,
      username: user.username,
      name: user.name,
      bio: user.bio,
      website: user.website,
      email: user.email,
      location: user.location
    };
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('users').child(user['.key']).update(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* removeEmptyProperties */])(updates)).then(function () {
        commit('setUser', { userId: user['.key'], user: user });
        resolve(user);
      });
    });
  },
  createThread: function createThread(_ref5, _ref6) {
    var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    var text = _ref6.text,
        title = _ref6.title,
        forumId = _ref6.forumId;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var threadId = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('threads').push().key; // 'greatThread' + Math.random()
      var postId = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('posts').push().key;
      var userId = state.authId;
      var publishedAt = Math.floor(Date.now() / 1000);
      var thread = { title: title, forumId: forumId, publishedAt: publishedAt, userId: userId, firstPostId: postId, posts: {} };
      thread.posts[postId] = postId;
      var post = { text: text, publishedAt: publishedAt, threadId: threadId, userId: userId };

      var updates = {};
      // set threads
      updates['threads/' + threadId] = thread;
      // append to forum
      updates['forums/' + forumId + '/threads/' + threadId] = threadId;
      // append to user
      updates['users/' + userId + '/threads/' + threadId] = threadId;

      // POST
      updates['posts/' + postId] = post;
      // updates[`threads/${threadId}/posts/${postId}`] = postId  >> bc Line 51
      updates['users/' + userId + '/posts/' + postId] = postId;
      console.log('updates', updates);
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref().update(updates).then(function () {
        commit('setItem', { resource: 'threads', item: thread, id: threadId }); // replaced << commit('setThread', { threadId, thread })
        commit('appendThreadToForum', { parentId: forumId, childId: threadId });
        commit('appendThreadToUser', { parentId: userId, childId: threadId });

        commit('setItem', { resource: 'posts', item: post, id: postId }); // removed << commit('setPost', {post, postId})
        commit('appendPostToThread', { parentId: post.threadId, childId: postId });
        commit('appendPostToUser', { parentId: post.userId, childId: postId });
        resolve(state.threads[threadId]);
      });

      commit('setItem', { resource: 'threads', item: thread, id: threadId }); // replaced << commit('setThread', { threadId, thread })
      commit('appendThreadToForum', { parentId: forumId, childId: threadId });
      commit('appendThreadToUser', { parentId: userId, childId: threadId });

      commit('setItem', { resource: 'posts', item: post, id: postId }); // removed << commit('setPost', {post, postId})
      commit('appendPostToThread', { parentId: post.threadId, childId: postId });
      commit('appendPostToUser', { parentId: post.userId, childId: postId });
      resolve(state.threads[threadId]);
    });
  },
  createUser: function createUser(_ref7, _ref8) {
    var state = _ref7.state,
        commit = _ref7.commit;
    var id = _ref8.id,
        email = _ref8.email,
        name = _ref8.name,
        username = _ref8.username,
        _ref8$avatar = _ref8.avatar,
        avatar = _ref8$avatar === undefined ? null : _ref8$avatar;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var registeredAt = Math.floor(Date.now() / 1000);
      var usernameLower = username.toLowerCase();
      email = email.toLowerCase();
      var user = { avatar: avatar, email: email, name: name, username: username, usernameLower: usernameLower, registeredAt: registeredAt
        // const userId = firebase.database().ref('users').push().key
      };__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('users').child(id).set(user).then(function () {
        commit('setItem', { resource: 'users', id: id, item: user });
        resolve(state.users[id]);
      });
    });
  },
  registerUserWithEmailandPassword: function registerUserWithEmailandPassword(_ref9, _ref10) {
    var dispatch = _ref9.dispatch;
    var email = _ref10.email,
        name = _ref10.name,
        username = _ref10.username,
        password = _ref10.password,
        _ref10$avatar = _ref10.avatar,
        avatar = _ref10$avatar === undefined ? null : _ref10$avatar;

    return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().createUserWithEmailAndPassword(email, password).then(function (user) {
      return dispatch('createUser', { id: user.user.uid, email: email, name: name, username: username, password: password, avatar: avatar });
    }).then(function () {
      return dispatch('fetchAuthUser');
    });
    // onAuthStateChanged in main.js is taking care of this .then(() => dispatch('fetchAuthUser'))
  },
  initAuthentication: function initAuthentication(_ref11) {
    var dispatch = _ref11.dispatch,
        commit = _ref11.commit,
        state = _ref11.state;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (state.unsubescribeAuthObserver) {
        state.unsubescribeAuthObserver();
      }
      var unsubscribe = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().onAuthStateChanged(function (user) {
        console.log('user has changed');
        if (user) {
          dispatch('fetchAuthUser').then(function (dbUser) {
            return resolve(dbUser);
          });
        } else {
          resolve(null);
        }
      });
      commit('setUnsubescribeAuthObserver', unsubscribe);
    });
  },
  fetchAuthUser: function fetchAuthUser(_ref12) {
    var dispatch = _ref12.dispatch,
        commit = _ref12.commit;

    var userId = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('users').child(userId).once('value', function (snapshot) {
        if (snapshot.exists()) {
          return dispatch('fetchUser', { id: userId }).then(function (user) {
            commit('setAuthId', userId);
            resolve(user);
          });
        } else {
          resolve(null);
        }
      });
    });
  },
  signinWithEmailAndPassword: function signinWithEmailAndPassword(context, _ref13) {
    var email = _ref13.email,
        password = _ref13.password;

    return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signInWithEmailAndPassword(email, password);
  },
  signinWithGoogle: function signinWithGoogle(_ref14) {
    var dispatch = _ref14.dispatch;

    var provider = new __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth.GoogleAuthProvider();
    return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signInWithPopup(provider).then(function (data) {
      var user = data.user;
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('users').child(user.uid).once('value', function (snapshot) {
        if (!snapshot.exists()) {
          return dispatch('createUser', { id: user.uid, name: user.displayName, email: user.email, username: user.email, avatar: user.photoURL }).then(function () {
            return dispatch('fetchAuthUser');
          });
        }
      });
    });
  },
  signOut: function signOut(_ref15) {
    var commit = _ref15.commit;

    return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signOut().then(function () {
      commit('setAuthId', null);
    });
  },
  updateThread: function updateThread(_ref16, _ref17) {
    var state = _ref16.state,
        commit = _ref16.commit;
    var title = _ref17.title,
        text = _ref17.text,
        id = _ref17.id;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var thread = state.threads[id];
      var post = state.posts[thread.firstPostId];
      var edited = {
        at: Math.floor(Date.now() / 1000),
        by: state.authId
      };

      var updates = {};
      updates['posts/' + thread.firstPostId + '/text'] = text;
      updates['posts/' + thread.firstPostId + '/edited'] = edited;
      updates['threads/' + id + '/title'] = title;
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref().update(updates).then(function () {
        commit('setThread', { thread: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, thread, { title: title }), threadId: id });
        commit('setPost', { post: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, post, { text: text }), postId: thread.firstPostId });
        resolve(post);
      });
    });
  },

  fetchThreads: function fetchThreads(_ref18, _ref19) {
    var dispatch = _ref18.dispatch;
    var ids = _ref19.ids;
    return dispatch('fetchItems', { ids: ids, itemType: 'Thread', resource: 'threads' });
  },
  fetchForums: function fetchForums(_ref20, _ref21) {
    var dispatch = _ref20.dispatch;
    var ids = _ref21.ids;
    return dispatch('fetchItems', { resource: 'forums', ids: ids, itemType: '_Forums' });
  },
  fetchUsers: function fetchUsers(_ref22, _ref23) {
    var dispatch = _ref22.dispatch;
    var ids = _ref23.ids;
    return dispatch('fetchItems', { resource: 'users', ids: ids, itemType: '_Users' });
  },
  fetchPosts: function fetchPosts(_ref24, _ref25) {
    var dispatch = _ref24.dispatch;
    var ids = _ref25.ids;
    return dispatch('fetchItems', { resource: 'posts', ids: ids, itemType: '_Post' });
  },
  fetchCategories: function fetchCategories(_ref26, _ref27) {
    var dispatch = _ref26.dispatch;
    var ids = _ref27.ids;
    return dispatch('fetchItems', { resource: 'categories', ids: ids, itemType: '_Categories' });
  },

  fetchThread: function fetchThread(_ref28, _ref29) {
    var dispatch = _ref28.dispatch;
    var id = _ref29.id;
    return dispatch('fetchItem', { id: id, itemType: 'Thread', resource: 'threads' });
  },
  fetchUser: function fetchUser(_ref30, _ref31) {
    var dispatch = _ref30.dispatch;
    var id = _ref31.id;
    return dispatch('fetchItem', { id: id, itemType: 'User', resource: 'users' });
  },
  fetchPost: function fetchPost(_ref32, _ref33) {
    var dispatch = _ref32.dispatch;
    var id = _ref33.id;
    return dispatch('fetchItem', { id: id, itemType: 'Post', resource: 'posts' });
  },
  fetchCategory: function fetchCategory(_ref34, _ref35) {
    var dispatch = _ref34.dispatch;
    var id = _ref35.id;
    return dispatch('fetchItem', { id: id, resource: 'categories', itemType: '_catagory' });
  },
  fetchForum: function fetchForum(_ref36, _ref37) {
    var dispatch = _ref36.dispatch;
    var id = _ref37.id;
    return dispatch('fetchItem', { id: id, resource: 'forums', itemType: '_forum' });
  },

  fetchItem: function fetchItem(_ref38, _ref39) {
    var state = _ref38.state,
        commit = _ref38.commit;
    var id = _ref39.id,
        itemType = _ref39.itemType,
        resource = _ref39.resource;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref(resource).child(id).once('value', function (snapshot) {
        commit('setItem', { resource: resource, id: snapshot.key, item: snapshot.val() });
        resolve(state[resource][id]);
        // setTimeout(() => resolve(state[resource][id]), 100)
      });
    });
  },
  fetchItems: function fetchItems(_ref40, _ref41) {
    var dispatch = _ref40.dispatch;
    var ids = _ref41.ids,
        resource = _ref41.resource,
        itemType = _ref41.itemType;

    ids = Array.isArray(ids) ? ids : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(ids);
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(ids.map(function (id) {
      return dispatch('fetchItem', { id: id, resource: resource, itemType: itemType });
    }));
  },
  fetchAllCategories: function fetchAllCategories(_ref42) {
    var state = _ref42.state,
        commit = _ref42.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('categories').once('value', function (snapshot) {
        var categoriesObject = snapshot.val();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(categoriesObject).forEach(function (categoryId) {
          var category = categoriesObject[categoryId];
          commit('setItem', { resource: 'categories', id: categoryId, item: category });
        });
        resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.categories));
      });
    });
  }
});

/***/ }),

/***/ "msPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Create new thread in "),_c('i',[_vm._v(_vm._s(_vm.forum.name))])]),_vm._v(" "),_c('ThreadEditor',{ref:"editor",on:{"save":_vm.save,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nJYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    'user': 'authUser'
  })),
  data: function data() {
    return {
      userDropdownOpen: true
    };
  }
});

/***/ }),

/***/ "nVtz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostList__ = __webpack_require__("DeYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserProfileCart__ = __webpack_require__("JO/1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UserProfileCartEditor__ = __webpack_require__("OxT7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import store from '@/store'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PostList: __WEBPACK_IMPORTED_MODULE_1__components_PostList__["a" /* default */],
    UserProfileCart: __WEBPACK_IMPORTED_MODULE_2__components_UserProfileCart__["a" /* default */],
    UserProfileCartEditor: __WEBPACK_IMPORTED_MODULE_3__components_UserProfileCartEditor__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__["a" /* default */]],
  created: function created() {
    var _this = this;

    this.$store.dispatch('fetchPosts', { ids: this.user.posts ? this.user.posts : [] }).then(function () {
      return _this.asyncDataStatus_fetched();
    });
    // this.$emit('ready')
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'authUser'
  }), {
    // moved to sub_cards as computed
    // userThreadsCount () {
    //   return this.$store.getters.userThreadsCount(this.user['.key'])
    // // return countObjectProperties(this.user.threads)
    // //   return this.user.threads ^^moved
    // //   ? Object.keys(this.user.threads).length
    // //   : 0
    // },
    // userPostsCount () {
    //   return this.$store.getters.userPostsCount(this.user['.key'])
    // //  return countObjectProperties(this.user.posts)
    // //   return this.user.posts
    // //   ? Object.keys(this.user.posts).length
    // //   : 0
    // },
    userPosts: function userPosts() {
      // if (this.user.posts) {
      //   return Object.values(this.$store.state.posts)
      //     .filter(post => post.userId === this.user['.key'])
      // }
      // return []
      // ^^ moved to getters
      return this.$store.getters.userPosts(this.user['.key']);
    }
  })
  // beforeRouteEnter (to, from, next) {
  //   // if (store.state.authId) {
  //   //   next()
  //   // } else {
  //   //   next({name: 'Home'}) // or next('/')
  //   // }
  // },
  // beforeRouteUpdate (to, from, next) {
  //   // ... not implimented
  // },
  // beforeRouteLeave (to, from, next) {
  //   // ... not implimented
  // }
});

/***/ }),

/***/ "oEgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadListItem_vue__ = __webpack_require__("pPvV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89af2672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadListItem_vue__ = __webpack_require__("mP6G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89af2672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pPvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import sourceData from '@/data'
// import AppDate from './AppDate'
// import {countObjectProperties} from '@/utils/index' >> removed using vuex.getters instead

/* harmony default export */ __webpack_exports__["a"] = ({
  // components: {
  //   AppDate
  // },
  props: {
    thread: {
      required: true,
      type: Object
    }
  },
  computed: {
    repliesCount: function repliesCount() {
      return this.$store.getters.threadRepliesCount(this.thread['.key']);
      // return countObjectProperties(this.thread.posts) - 1
      // return Object.keys(this.thread.posts).length - 1
    },
    user: function user() {
      return this.$store.state.users[this.thread.userId];
    }
  }
});

/***/ }),

/***/ "rQVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    timestamp: {
      required: true,
      type: Number
    }
  },
  filters: {
    humanFriendlyDate: function humanFriendlyDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    diffForHuman: function diffForHuman(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(date).fromNow();
    }
  }

});

/***/ }),

/***/ "rlI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__ = __webpack_require__("jmvG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8ebb4c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__ = __webpack_require__("m0Of");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8ebb4c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "skxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ThreadList__ = __webpack_require__("COEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import sourceData from '@/data'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadList: __WEBPACK_IMPORTED_MODULE_4__components_ThreadList__["a" /* default */]
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__["a" /* default */]],
  computed: {
    forum: function forum() {
      return this.$store.state.forums[this.id];
    },
    threads: function threads() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.$store.state.threads).filter(function (thread) {
        return thread.forumId === _this.id;
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchForum', 'fetchThreads', 'fetchUser'])),
  created: function created() {
    var _this2 = this;

    this.fetchForum({ id: this.id }).then(function (forum) {
      return _this2.fetchThreads({ ids: forum.threads });
    }).then(function (threads) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(threads.map(function (thread) {
        return _this2.fetchUser({ id: thread.userId });
      }));
    }).then(function () {
      return _this2.asyncDataStatus_fetched();
    });
    // OLD: we changed forEach to map
    // threads.forEach(thread => this.fetchUser({id: thread.userId}))
  }
});

/***/ }),

/***/ "tFgn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u7GP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryListItem_vue__ = __webpack_require__("3YjU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f4ef32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryListItem_vue__ = __webpack_require__("J/FS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f4ef32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var makeAppendChildToParrentMutation = function makeAppendChildToParrentMutation(_ref) {
  var parent = _ref.parent,
      child = _ref.child;
  return function (state, _ref2) {
    var childId = _ref2.childId,
        parentId = _ref2.parentId;

    var resource = state[parent][parentId]; // == user.name === user['name']
    if (!resource[child]) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(resource, child, {});
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(resource[child], childId, childId);
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setItem: function setItem(state, _ref3) {
    var item = _ref3.item,
        id = _ref3.id,
        resource = _ref3.resource;

    item['.key'] = id;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state[resource], id, item);
  },
  setThread: function setThread(state, _ref4) {
    var thread = _ref4.thread,
        threadId = _ref4.threadId;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.threads, threadId, thread);
  },
  setUser: function setUser(state, _ref5) {
    var user = _ref5.user,
        userId = _ref5.userId;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.users, userId, user);
  },
  setPost: function setPost(state, _ref6) {
    var post = _ref6.post,
        postId = _ref6.postId;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.posts, postId, post);
    // ^- replace this.$set(this.$store.state.posts, postId, post)
  },
  setAuthId: function setAuthId(state, id) {
    state.authId = id;
  },
  setUnsubescribeAuthObserver: function setUnsubescribeAuthObserver(state, unsubscribe) {
    state.unsubescribeAuthObserver = unsubscribe;
  },

  appendPostToThread: makeAppendChildToParrentMutation({ parent: 'threads', child: 'posts' }),
  // ^^ replaced with higher order func
  // appendPostToThread (state, {postId, threadId}) {
  //   const thread = state.threads[threadId]
  //   if (!thread.posts) {
  //     Vue.set(thread, 'posts', {})
  //   }
  //   Vue.set(thread.posts, postId, postId)
  // // ^- this.$set(this.thread.posts, postId, postId)
  // },
  appendContributorToThread: makeAppendChildToParrentMutation({ parent: 'threads', child: 'contributors' }),
  appendPostToUser: makeAppendChildToParrentMutation({ parent: 'users', child: 'posts' }),
  // ^^ replaced with higher order func
  // appendPostToUser (state, {postId, userId}) {
  //   const user = state.users[userId]
  //   if (!user.posts) {
  //     Vue.set(user, 'posts', {})
  //   }
  //   Vue.set(user.posts, postId, postId)
  // // ^- this.$set(this.$store.state.users[post.userId].posts, postId, postId)
  // },
  appendThreadToForum: makeAppendChildToParrentMutation({ parent: 'forums', child: 'threads' }),
  // ^^ replaced with higher order func
  // appendThreadToForum (state, {forumId, threadId}) {
  //   const forum = state.forums[forumId]
  //   if (!forum.posts) {
  //     Vue.set(forum, 'threads', {})
  //   }
  //   Vue.set(forum.threads, threadId, threadId)
  // },
  appendThreadToUser: makeAppendChildToParrentMutation({ parent: 'users', child: 'threads' })
  // ^^ replaced with higher order func
  // appendThreadToUser (state, {threadId, userId}) {
  //   const user = state.users[userId]
  //   if (!user.threads) {
  //     Vue.set(user, 'threads', {})
  //   }
  //   Vue.set(user.threads, threadId, threadId)
  // }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "w+/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    threadId: {
      required: false
    },
    post: {
      type: Object,
      validator: function validator(obj) {
        var keyIsValid = typeof obj['.key'] === 'string';
        var textIsValid = typeof obj.text === 'string';
        var valid = keyIsValid && textIsValid;
        if (!keyIsValid) {
          console.error('the post prop object must inlcude a `.key` attributes');
        }
        if (!textIsValid) {
          console.error('the post prop object must inlcude a `text` attributes');
        }
        return valid;
      }
    }
  },
  data: function data() {
    return {
      text: this.post ? this.post.text : ''
    };
  },

  computed: {
    isUpdate: function isUpdate() {
      return !!this.post;
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      this.persist().then(function (post) {
        _this.$emit('save', { post: post });
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    create: function create() {
      var post = {
        text: this.text,
        threadId: this.threadId
      };
      this.text = '';
      return this.$store.dispatch('createPost', post);
    },
    update: function update() {
      var payload = {
        id: this.post['.key'],
        text: this.text
      };

      return this.$store.dispatch('updatePost', payload);
    },
    persist: function persist() {
      return this.isUpdate ? this.update() : this.create();
    }
  }
});

/***/ }),

/***/ "w+aQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect1"}),_vm._v(" "),_c('div',{staticClass:"rect2"}),_vm._v(" "),_c('div',{staticClass:"rect3"}),_vm._v(" "),_c('div',{staticClass:"rect4"}),_vm._v(" "),_c('div',{staticClass:"rect5"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wEhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadEditor_vue__ = __webpack_require__("NMPn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e81b13a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadEditor_vue__ = __webpack_require__("6jfm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e81b13a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wSRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSpinner_vue__ = __webpack_require__("ZH5V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc324462_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSpinner_vue__ = __webpack_require__("w+aQ");
function injectStyle (ssrContext) {
  __webpack_require__("HXr5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc324462"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc324462_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheNavbar__ = __webpack_require__("9TRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppSpinner__ = __webpack_require__("wSRz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TheNavbar: __WEBPACK_IMPORTED_MODULE_0__components_TheNavbar__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_AppSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      showPage: false
    };
  },

  methods: {
    pageReady: function pageReady() {
      this.showPage = true;
      __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done();
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.configure({
      speed: 500,
      showSpinner: false
    });
    this.$router.beforeEach(function (to, from, next) {
      _this.showPage = false;
      __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.start();
      next();
    });
  }
  // ,name: 'app'

});

/***/ }),

/***/ "y4/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grid"},[(!_vm.edit)?_c('UserProfileCart',{attrs:{"user":_vm.user}}):_c('UserProfileCartEditor',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('div',{staticClass:"col-7 push-top"},[_c('div',{staticClass:"profile-header"},[_c('span',{staticClass:"text-lead"},[_vm._v("\n                  "+_vm._s(_vm.user.username)+"'s recent activity\n              ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_vm._v("See only started threads?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('PostList',{attrs:{"posts":_vm.userPosts}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zosi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHome_vue__ = __webpack_require__("lMYB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2551bff0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHome_vue__ = __webpack_require__("arqx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2551bff0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.72700c9d4231a9d8db21.js